/*
  KoreanSpa bundle gifts
  Keeps free gift lines in sync with the cart:
  - a subscription line whose variant has custom.bundle_gifts unlocks those gift variants (1 each)
  - gift lines are added with the hidden property _ks_gift and removed when no longer unlocked
  The expected/present state is rendered by snippets/cart-drawer.liquid (#ks-gift-state)
  and, on the cart page, by sections/main-cart-items.liquid (#ks-gift-state-page, preferred when present).
  Prices are set to $0 by the Shopify automatic discount (Buy X get Y), not by this script.
*/
(function () {
  if (window.ksBundleGifts) return;
  window.ksBundleGifts = true;

  var busy = false;
  var timer = null;
  var attempts = 0;
  var MAX_ATTEMPTS = 3;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function readState() {
    var el = document.getElementById('ks-gift-state-page') || document.getElementById('ks-gift-state');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json();
    });
  }

  function applySections(sections) {
    if (!sections) return;
    var parser = new DOMParser();

    if (sections['cart-drawer']) {
      var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
      var src = doc.querySelector('.drawer__inner');
      var dst = document.querySelector('#CartDrawer .drawer__inner');
      if (src && dst) dst.innerHTML = src.innerHTML;
      var drawer = document.querySelector('cart-drawer');
      var srcDrawer = doc.querySelector('cart-drawer');
      if (drawer && srcDrawer) drawer.classList.toggle('is-empty', srcDrawer.classList.contains('is-empty'));
    }

    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var bubbleDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
      var bubbleSrc = bubbleDoc.querySelector('.shopify-section') || bubbleDoc.body;
      if (bubble && bubbleSrc) bubble.innerHTML = bubbleSrc.innerHTML;
    }
  }

  function refresh() {
    return fetch(root() + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) {
        return r.json();
      })
      .then(applySections);
  }

  function sync() {
    if (busy) return;
    var state = readState();
    if (!state) return;

    var expected = state.expected || [];
    var present = state.present || [];
    var changes = [];
    var adds = [];

    present.forEach(function (line) {
      if (expected.indexOf(line.id) === -1) changes.push({ id: line.key, quantity: 0 });
      else if (line.qty !== 1) changes.push({ id: line.key, quantity: 1 });
    });

    expected.forEach(function (id) {
      var found = present.some(function (line) {
        return line.id === id;
      });
      if (!found) adds.push({ id: id, quantity: 1, properties: { _ks_gift: '1' } });
    });

    if (!changes.length && !adds.length) {
      attempts = 0;
      try { sessionStorage.removeItem('ksGiftReloads'); } catch (e) {}
      return;
    }
    if (attempts >= MAX_ATTEMPTS) return;
    attempts += 1;
    busy = true;

    var drawerItems = document.querySelector('#CartDrawer-CartItems');
    if (drawerItems) drawerItems.style.opacity = '0.6';

    var chain = Promise.resolve();
    changes.forEach(function (change) {
      chain = chain.then(function () {
        return postJSON(root() + 'cart/change.js', change);
      });
    });
    if (adds.length) {
      chain = chain.then(function () {
        return postJSON(root() + 'cart/add.js', { items: adds });
      });
    }

    chain
      .then(function () {
        /* Cart page: reload so the page rows, totals and footer are rebuilt */
        if (document.getElementById('ks-gift-state-page')) {
          var n = 0;
          try { n = parseInt(sessionStorage.getItem('ksGiftReloads') || '0', 10); } catch (e) {}
          if (n < 2) {
            try { sessionStorage.setItem('ksGiftReloads', String(n + 1)); } catch (e) {}
            window.location.reload();
            return new Promise(function () {});
          }
        }
        return refresh();
      })
      .catch(function (e) {
        console.error('[ks-bundle-gifts]', e);
      })
      .finally(function () {
        busy = false;
        var items = document.querySelector('#CartDrawer-CartItems');
        if (items) items.style.opacity = '';
        schedule();
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 150);
  }

  function start() {
    var targets = [document.getElementById('CartDrawer'), document.getElementById('main-cart-items')].filter(Boolean);
    if (!targets.length) return;
    targets.forEach(function (target) {
      new MutationObserver(function () {
        if (!busy) schedule();
      }).observe(target, { childList: true, subtree: true });
    });
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
